module.exports = __webpack_public_path__ + "static/media/pic_liucheng.eebfd8c9.png";